<div page-header-area="icon" class="tenant-logo"
	[style.background-image]="tenantLogo() ? ('url(' + tenantLogo() + ')') : ''"
	[routerLink]="Routes.getMobileHomeFullPath()"
></div>

<div class="mobile-tenant-name text-center text-muted overflow-hidden">
	{{ tenantName() }}
	<div class="context-title">{{ title.getTitle() }}</div>
</div>

<div class="user-actions">
	@if (!!user()) {
		<div data-testid="UserAccountMenu" class="user-account" ngbDropdown placement="bottom-right" (openChange)="userMenuOpened()">
			<user-avatar [user]="user()" [hasPopover]="false" ngbDropdownToggle data-cy="DropdownToggle" class="no-carret"/>
			<div ngbDropdownMenu>
				<div class="d-flex flex-column">
					@if ((config$ | async).consoleUrl) {
						<button data-cy="LeavePlatform" class="dropdown-item" (click)="leavePlatform()">
							<i class="mr-2 fa fa-door-open"></i> {{ 'TopBar.Account.Leave' | translate }}</button>
					}

					<button data-cy="Logout" class="dropdown-item" (click)="userLogout()">
						<i class="mr-2 fa fa-power-off"></i> {{ 'TopBar.Account.LogOut' | translate }}</button>
				</div>
			</div>
		</div>
	}
</div>
